import { render, staticRenderFns } from "./CollectiveDetailInfo.vue?vue&type=template&id=5177bbf3&scoped=true"
import script from "./CollectiveDetailInfo.vue?vue&type=script&lang=js"
export * from "./CollectiveDetailInfo.vue?vue&type=script&lang=js"
import style0 from "./CollectiveDetailInfo.vue?vue&type=style&index=0&id=5177bbf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5177bbf3",
  null
  
)

export default component.exports